import React from 'react';
import { withTranslation } from 'react-i18next';
import Backend from '../../Layouts/Backend';
import { Circle, Rect, Square, Chart } from './Shapes';
import { Alert } from '../../UI/Common';
import ContextMenu from '../../UI/Datagrid/ContextMenu';

const MapViewerPage = ({ t, ...props }) => {
  const { mapImage, mapShapes, alarmStatus, alarmStatusByGroup } = props;
  const [ctxState, setCtxState] = React.useState({
    openCtxMenu: false,
    ctxMenuCoord: null,
    ctxMenuRow: null,
    ctxMenuIdx: null,
    rowEvents: null,
  });
  function getValue(sensorId, alarmStatus) {
    if (alarmStatus.length) {
      const alarm = alarmStatus.filter((al) => al.sensorId === sensorId);
      if (alarm.length) {
        return `${alarm[0].textValue} ${alarm[0].units}`;
      }
      return null;
    }
    return null;
  }
  function getALByGroupValue(groupId, alarmStatusByGroup) {
    if (alarmStatusByGroup.length) {
      const alarm = alarmStatusByGroup.filter((al) => al.groupId === groupId);
      if (alarm.length) {
        return `${alarm[0].textValue} ${alarm[0].units}`;
      }
      return null;
    }
    return null;
  }
  function getBgColor(sensorId, alarmStatus) {
    if (alarmStatus.length) {
      if (alarmStatus.length) {
        const alarm = alarmStatus.filter((al) => al.sensorId === sensorId);
        if (alarm.length) {
          const alarmPriority = alarm[0].alarmPriority;
          let color;
          switch (alarmPriority) {
            case 0:
              //green
              color = '#28a745';
              break;
            case 1:
              //yellow
              color = '#FFFF80';
              break;
            case 2:
              //red
              color = '#FF8080';
              break;
            default:
              //blue
              color = '#80FFFF';
              break;
          }
          return color;
        }
        return null;
      }
      return null;
    }
  }
  function getSquareBgColor(groupId, alarmStatus) {
    if (alarmStatus.length) {
      const alarm = alarmStatus.filter((al) => al.groupId === groupId);
      if (alarm.length) {
        let color;
        let alarmPriority = alarm.map((al) => al.alarmPriority);
        function checkingExisting(value) {
          return alarmPriority.findIndex((el) => el === value) !== -1;
        }
        if (checkingExisting(3)) {
          color = '#80FFFF';
          return color;
        } else if (checkingExisting(2)) {
          color = '#FF8080';
          return color;
        } else if (checkingExisting(1)) {
          color = '#FFFF80';
          return color;
        } else {
          color = '#28A745';
          return color;
        }
      }
      return null;
    }
    return null;
  }
  function getId({ className, ...ex }, index) {
    let id = '';
    if (className === 'SquareShape') {
      id = `shape${ex.groupId}${index}${ex.x}${ex.y}`;
    } else {
      id = `shape${ex.sensorId}${ex.x}${ex.y}`;
    }
    return id;
  }

  function toggleContextMenu(e) {
    let update = { openCtxMenu: !ctxState.openCtxMenu };
    if (e) {
      update = Object.assign(update, {
        ctxMenuCoord: { x: e.clientX, y: e.clientY },
      });
    }
    setCtxState({ ...ctxState, ...update });
  }
  const ctxMenuOptions = [
    [
      {
        name: 'Edit map',
        action: (row, rowIndex) => {
          props.history.push(
            `/configure/map-management/edit?deptId=${props.deptId}&mapName=${props.mapName}`,
          );
        },
      },
      {
        name: 'Edit department',
        action: (row, rowIndex) => {
          props.history.push(
            `/configure/departments/department-settings/${props.deptId}`,
          );
        },
      },
    ],
  ];
  if (props.mapGroupId) {
    ctxMenuOptions[0].push({
      name: 'Edit group',
      action: (row, rowIndex) => {
        props.history.push(`/configure/groups/edit-group/${props.mapGroupId}`);
      },
    });
  }
  return (
    <Backend>
      <div className="content-inner" style={{ paddingTop: 10 }}>
        <Alert.Error text={props.errors} />
        <div className="d-flex flex-column flex-1 h-100">
          <div
            className="position-relative d-flex flex-1"
            style={{ overflow: 'auto' }}
            // style={{
            //   width: mapShapes.width || '100%',
            //   height: mapShapes.height || '100%',
            // }}
            onContextMenu={(e) => {
              e.preventDefault();
              setCtxState({
                openCtxMenu: true,
                ctxMenuCoord: { x: e.clientX, y: e.clientY },
              });
            }}
          >
            <ContextMenu
              {...ctxState}
              id={props.ctxMenuId}
              ctxMenuOptions={ctxMenuOptions}
              toggleFunc={toggleContextMenu}
            />
            <div>
              <img
                src={mapImage}
                width={mapShapes.width}
                height={mapShapes.height}
                className="bg-img position-absolute"
                alt="map-background"
              />
            </div>
            {Object.keys(mapShapes).length &&
              mapShapes.shapes.map((ex, index) => {
                const id = getId(ex, index);
                if (ex.className === 'CircleShape') {
                  return (
                    <Circle
                      key={id}
                      id={id}
                      w={ex.width}
                      h={ex.height}
                      fill={getBgColor(ex.sensorId, alarmStatus)}
                      {...ex}
                    />
                  );
                }
                if (ex.className === 'Multi') {
                  return (
                    <Rect
                      key={id}
                      id={id}
                      w={ex.width}
                      h={ex.height}
                      value={getValue(ex.sensorId, alarmStatus)}
                      fill={
                        ex.valueBackGroundColor === 'alarm'
                          ? getBgColor(ex.sensorId, alarmStatus)
                          : ex.valueBackGroundColor
                      }
                      {...ex}
                    />
                  );
                }
                if (ex.className === 'SquareShape') {
                  return (
                    <Square
                      key={id}
                      id={id}
                      w={ex.width}
                      h={ex.height}
                      value={getALByGroupValue(ex.groupId, alarmStatusByGroup)}
                      fill={getSquareBgColor(ex.groupId, alarmStatusByGroup)}
                      {...ex}
                    />
                  );
                }
                if (ex.className === 'Chart') {
                  return (
                    <Chart
                      key={id}
                      id={id}
                      w={ex.width}
                      h={ex.height}
                      refreshRate={props.refreshRate}
                      {...ex}
                    />
                  );
                }
              })}
          </div>
          <div className="d-flex justify-content-end">
            <span>
              {t('Last Updated')}: {props.lastUpdated}
            </span>
          </div>
        </div>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(MapViewerPage);
